import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { alert_pop } from '../redux/actions/notifications';

class Alert extends React.Component {
  constructor( props ) {
    super( props );
    this.interval = 0;
    this.state = {
      eventKey: this.props.eventKey === undefined ? '' : this.props.eventKey,
      type: this.props.type === undefined ? 'info' : this.props.type,
      title:  this.props.title === undefined ? 'info' : this.props.title,
      message: this.props.message === undefined ? '' : this.props.message,
      published: this.props.published === undefined ? '' : this.props.published,
      timeout: this.props.timeout === undefined ? 0 : this.props.timeout,
      closing: false,
    };

    // Render guards
    this._ismounted = undefined;
    this._timeout = undefined;
  }

  // Sets the timeout timer and render flag
  componentDidMount( ) {
    this._ismounted = true;
    const timeout = this.state.timeout;
    if( timeout > 0 ) {
      const onExpireAlert = ( ) => {
        this.onHandleClose( this );
      };
      this._timeout = setTimeout( function() {
        onExpireAlert( this );
      },
      timeout
      );
    }
  }

  // Clears the timeout timer and unsets mounted flag
  componentWillUnmount() {
    this._ismounted = false;
    if( this._timeout !== undefined ){
      clearTimeout( this._timeout );
    }
  }

  componentWillReceiveProps( nextProps ) {
    if( this._ismounted === true ){
      this.setState( {
        eventKey: nextProps.eventKey === undefined ? '' : nextProps.eventKey,
        type: nextProps.type === undefined ? 'info' : nextProps.type,
        title:  nextProps.title === undefined ? 'info' : nextProps.title,
        message: nextProps.message === undefined ? '' : nextProps.message,
        published: nextProps.published === undefined ? '' : nextProps.published,
        timeout: nextProps.timeout === undefined ? 0 : nextProps.timeout
      } );
    }
  }

  onHandleClose( e ) {

    if( this._ismounted === true ){
      const onHandleClose = () => {
        if( this.props.onClose !== undefined ) {
          const args = { type: this.state.type, key: this.state.eventKey };
          this.props.onClose( args, e );
        }
      };

      this.setState( {
        closing: true
      } );

      setTimeout( function(){
        onHandleClose();
      },
      400 );
    }
  }

  getIcon( type ) {
    if( type !== undefined ) {
      if( type.toString().toLowerCase() === 'info' ) {
        return 'notification-icon icon-fontello-info-circled';
      }

      if( type.toString().toLowerCase() === 'warning' ) {
        return 'notification-icon icon-fontello-warning';
      }

      if( type.toString().toLowerCase() === 'critical' ) {
        return 'notification-icon icon-fontello-error-alt';
      }

      if( type.toString().toLowerCase() === 'success' ) {
        return 'notification-icon icon-fontello-thumbs-up-alt';
      }
    }
    return 'notification-icon icon-fontello-info-circled';
  }

  render( ) {
    const key = this.state.eventKey;
    const type = this.state.type;
    const title = this.state.title;
    const message = this.state.message;
    const published = this.state.published;
    let className='notification-' + type.toString().toLowerCase();
    let iconClassName = this.getIcon( type );
    if( this.state.closing === false ) {
      return (
        <span key={key} className={className}>
          <div className="notification-header">
            <i className={iconClassName}></i>
            <span className="notification-title">
              {title}
            </span>
            <span className="notification-close icon-ikons-close" onClick={this.onHandleClose.bind( this )}></span>
          </div>
          <div className="notification-body">
            {message}
          </div>
          <div className="notification-footer">
              Posted: <strong>{published}</strong>
          </div>
        </span>
      );
    } else {
      className += '-remove';
      return (
        <span key={key} className={className}>
          <div className="notification-header">
            <i className={iconClassName}></i>
            <span className="notification-title">
              {title}
            </span>
            <span className="notification-close icon-ikons-close"></span>
          </div>
          <div className="notification-body">
            {message}
          </div>
          <div className="notification-footer">
              Posted: <strong>{published}</strong>
          </div>
        </span>
      );
    }
  }
}

class Notification extends React.Component {

  constructor( props ) {
    super( props );

    // Bindings
    this.createAlert = this.createAlert.bind( this );
    this.onHandleClose = this.onHandleClose.bind( this );
    this.renderNotifications = this.renderNotifications.bind( this );

    // Render guard (not used in this component as setState is not included in any function)
    // leaving incase features are added
    this._ismounted = undefined;
  }

  // Sets the render/setState flag
  componentDidMount(){
    this._ismounted = true;
  }

  // Unsets the render/setState flag
  componentWillUnmount(){
    this._ismounted = false;
  }

  onHandleClose( alert, e ) {
    const { dispatch } = this.props;
    dispatch( alert_pop( alert.type, alert.key ) );
  }

  createAlert( type, key, title, message, published, timeout ) {
    return (
      <Alert key={'alert-notification-' + key} eventKey={key} type={type} title={title} message={message} published={published} timeout={timeout} onClose={this.onHandleClose} />
    );
  }

  renderNotifications( ) {
    const notifications = this.props.notifications;
    let components = [];
    let index = 0;
    /* Build the info messages */
    const info = notifications.info;
    if( info.length > 0 ) {
      const count = info.length;
      for( index = 0; index < count; index++ ) {
        const infoItem = info[index];
        if( infoItem !== undefined ) {
          components.push( this.createAlert( infoItem.type, infoItem.key, infoItem.title, infoItem.message, infoItem.published, infoItem.timeout ) );
        }
      }
    }

    /* Build the warning messages */
    const warning = notifications.warning;
    if( warning.length > 0 ) {
      const count = warning.length;
      for( index = 0; index < count; index++ ) {
        const warningItem = warning[index];
        if( warningItem !== undefined ) {
          components.push( this.createAlert( warningItem.type, warningItem.key, warningItem.title, warningItem.message, warningItem.published, warningItem.timeout ) );
        }
      }
    }

    /* Build the critical messages */
    const critical = notifications.critical;
    if( critical.length > 0 ) {
      const count = critical.length;
      for( index = 0; index < count; index++ ) {
        const criticalItem = critical[index];
        if( criticalItem !== undefined ) {
          components.push( this.createAlert( criticalItem.type, criticalItem.key, criticalItem.title, criticalItem.message, criticalItem.published, criticalItem.timeout ) );
        }
      }
    }

    /* Build the success messages */
    const success = notifications.success;
    if( success.length > 0 ) {
      const count = success.length;
      for( index = 0; index < count; index++ ) {
        const successItem = success[index];
        if( successItem !== undefined ) {
          components.push( this.createAlert( successItem.type, successItem.key, successItem.title, successItem.message, successItem.published, successItem.timeout ) );
        }
      }
    }
    return components;
  }

  render ( ) {
    const notifications = this.renderNotifications();
    if( notifications.length > 0 ) {
      return (
        <span className="notifications">
          {notifications}
        </span>
      );
    } else {
      return '';
    }

  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        notifications: store.notifications
      };
    }
  )( Notification ) );



// WEBPACK FOOTER //
// ./src/presentation/Notification.js